var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPhone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9348 25.2821L26.0796 24.1374C26.8606 23.3563 26.8606 22.09 26.0796 21.3089L23.5231 18.7525C23.023 18.2524 22.3447 17.9714 21.6375 17.9714C20.9303 17.9714 20.252 18.2524 19.7519 18.7525L17.7478 20.7566C14.7377 19.634 12.3633 17.2597 11.2408 14.2496L13.2449 12.2455C14.2862 11.2041 14.2862 9.51567 13.2449 8.47428L10.6884 5.91782C10.3134 5.54275 9.80465 5.33203 9.27422 5.33203C8.74378 5.33203 8.23507 5.54275 7.86 5.91782L6.71526 7.06254C5.8306 7.94719 5.33312 9.14673 5.33204 10.3978V10.3978C5.32829 14.7134 7.04098 18.8533 10.0925 21.9048C13.1441 24.9564 17.284 26.6691 21.5995 26.6653V26.6653C22.8506 26.6643 24.0502 26.1668 24.9348 25.2821V25.2821Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phone.c67e1eb4.svg";
export { ForwardRef as ReactComponent };